/* eslint-disable max-lines */
import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';

import { STORE_SWITCHER_HEADER_ID } from 'Component/StoreSwitcher/StoreSwitcher.config';
import { showNotification } from 'Store/Notification/Notification.action';
import { closePopup, showPopup } from 'Store/Popup/Popup.action';
import { CountryType, HreflangsType } from 'Type/Stores.type';
import { setCookie } from 'Util/Cookies/Cookies';
import history from 'Util/History';

import StoreSelector from './StoreSelector.component';
import {
    COOKIE_LIFETIME,
    CURRENT_COUNTRY,
    HEADER_HEIGHT, NO_REDIRECT,
    TOUCH_TIMEOUT
} from './StoreSelector.config';

import './StoreSelector.style';

/** @namespace Bodypwa/Component/StoreSelector/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    device: state.ConfigReducer.device,
    currentStoreCode: state.ConfigReducer.default_country,
    storeCountries: state.ConfigReducer.countries,
    hreflangs: state.MetaReducer.hreflangs,
    countries: state.StoresReducer.countries,
    statusCode: state.MetaReducer.status_code,
    isNoHreflangs: !!state.MetaReducer.isNoHreflangs,
    isCountryPopUpActive: state.ConfigReducer.country_popup_active
});

/** @namespace Bodypwa/Component/StoreSelector/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    showErrorNotification: (message) => dispatch(showNotification('error', message)),
    showPopup: (id, payload) => dispatch(showPopup(id, payload)),
    closePopup: (id, payload) => dispatch(closePopup(id, payload))
});
/** @namespace Bodypwa/Component/StoreSelector/Container */
export class StoreSelectorContainer extends PureComponent {
    static propTypes = {
        showPopup: PropTypes.func.isRequired,
        closePopup: PropTypes.func.isRequired,
        toggleStoreSelector: PropTypes.func.isRequired,
        isOpened: PropTypes.bool.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        device: PropTypes.object.isRequired,
        searchValue: PropTypes.string.isRequired,
        selectedCountry: CountryType.isRequired,
        hreflangs: HreflangsType.isRequired,
        isSimple: PropTypes.bool.isRequired,
        currentStoreCode: PropTypes.string,
        storeSelectorId: PropTypes.string.isRequired,
        countries: PropTypes.arrayOf(CountryType).isRequired,
        currentCountry: CountryType,
        statusCode: PropTypes.string.isRequired,
        isNoHreflangs: PropTypes.bool.isRequired,
        storeCountries: PropTypes.arrayOf(CountryType).isRequired,
        isCountryPopUpActive: PropTypes.bool.isRequired,
        isPrefered: PropTypes.bool,
        customLabel: PropTypes.string,
        onRedirect: PropTypes.func
    };

    headerRef = createRef();

    static defaultProps = {
        currentCountry: {
            label: '',
            names: [],
            code: '',
            url: ''
        },
        currentStoreCode: 'default',
        isPrefered: false,
        customLabel: '',
        onRedirect: false
    };

    state = {
        searchValue: '',
        selectedCountry: {
            label: '',
            names: [],
            code: '',
            url: ''
        },
        isFitScreen: false,
        isActive: false,
        popUpHeight: window.innerHeight,
        directRedirect: false,
        isLoading: false
    };

    searchRef = createRef();

    containerFunctions = {
        toggleStoreSelectPopup: this.toggleStoreSelectPopup.bind(this),
        onStoreSwitcherClick: this.onStoreSwitcherClick.bind(this),
        onSearchChange: this.onSearchChange.bind(this),
        selectCountry: this.selectCountry.bind(this),
        goToShop: this.goToShop.bind(this),
        fitScreen: this.fitScreen.bind(this),
        resetSearch: this.resetSearch.bind(this),
        setActive: this.setActive.bind(this),
        enableScrolling: this.enableScrolling.bind(this),
        disableScrolling: this.disableScrolling.bind(this),
        stopScroll: this.stopScroll.bind(this),
        resetCountrySelect: this.resetCountrySelect.bind(this)
    };

    componentDidMount() {
        this.selectCountry();
    }

    componentDidUpdate(prevProps) {
        const {
            currentCountry: { code }, isSimple, currentStoreCode
        } = this.props;
        const { currentCountry: { code: prevCode } } = prevProps;
        const { selectedCountry: { code: selectedCountryCode } } = this.state;
        if ((code && code !== prevCode) || (isSimple && currentStoreCode !== selectedCountryCode)) {
            this.selectCountry();
        }
        this.handleDirectRedirect();
        this.updateLabel();
        this.adjustPopUpHeight();
    }

    updateLabel() {
        const { isSimple, currentStoreCode } = this.props;
        const { selectedCountry } = this.state;

        if (isSimple && !selectedCountry.label && currentStoreCode) {
            this.getCurrentLabel(currentStoreCode);
        }
    }

    adjustPopUpHeight() {
        setTimeout(() => {
            this.setPopUpHeight();
            // eslint-disable-next-line no-magic-numbers
        }, 15);
    }

    setPopUpHeight() {
        const { isFitScreen } = this.state;
        const height = window.visualViewport?.height || window.innerHeight;
        const popUpHeight = isFitScreen ? height + HEADER_HEIGHT : height - HEADER_HEIGHT;
        const { popUpHeight: prevPopUpHeight } = this.state;
        if (popUpHeight !== prevPopUpHeight) {
            this.setState({ popUpHeight });
        }
    }

    containerProps() {
        const {
            device,
            isSimple = false,
            storeSelectorId,
            countries,
            storeCountries,
            hreflangs,
            statusCode,
            isNoHreflangs,
            isCountryPopUpActive,
            customLabel
        } = this.props;

        const {
            searchValue, selectedCountry, isFitScreen, isActive, popUpHeight, isLoading
        } = this.state;

        return {
            device,
            searchValue,
            selectedCountry,
            isFitScreen,
            isActive,
            countries,
            storeCountries,
            storeSelectorId,
            searchRef: this.searchRef,
            headerRef: this.headerRef,
            isSimple,
            popUpHeight,
            hreflangs,
            statusCode,
            isNoHreflangs,
            isCountryPopUpActive,
            customLabel,
            isLoading
        };
    }

    getCurrentLabel(storeCode) {
        const { countries } = this.props;
        const currentCountry = countries.filter(
            ({ code }) => code === storeCode
        );

        if (!currentCountry.length) {
            return;
        }

        this.selectCountry(currentCountry[0], false);
    }

    fitScreen(toggle = true) {
        const { device } = this.props;
        this.setState({ isFitScreen: toggle && device.isMobile });
    }

    setActive(isActive = true) {
        const { isPrefered } = this.props;
        if (isPrefered) {
            return;
        }
        this.setState({ isActive });
    }

    onStoreSwitcherClick() {
        const { toggleStoreSelector, isOpened } = this.props;
        const isActive = {};
        isActive[STORE_SWITCHER_HEADER_ID] = true;
        toggleStoreSelector({ ...isOpened, ...isActive });
    }

    onSearchChange(e) {
        const { value: searchValue } = e.target;
        const { headerRef } = this;
        if (headerRef.current) {
            headerRef.current.parentElement.scrollTop = 0;
        }
        this.setState({ searchValue });
    }

    toggleStoreSelectPopup(show = true) {
        const {
            showPopup, closePopup, storeSelectorId, hreflangs = [], countries = [], statusCode, isNoHreflangs
        } = this.props;

        if (hreflangs !== null
            && ((hreflangs.length === 0 && statusCode !== '404') || countries.length === 0) && !isNoHreflangs) {
            return;
        }

        if (show) {
            showPopup(storeSelectorId, {
                title: __('Shipping country')
            });
        } else {
            closePopup(storeSelectorId, {});
        }
    }

    selectCountry(selectedCountry, directRedirect = false) {
        const { currentCountry } = this.props;
        const { isPrefered } = this.props;
        this.setState({ selectedCountry: selectedCountry || currentCountry, searchValue: '', directRedirect });
        if (!isPrefered) {
            this.toggleStoreSelectPopup(false);
        }
    }

    goToShop(selectedCountry, isPrefered = false) {
        const {
            url, locale, code, store_id
        } = selectedCountry;

        const { isPrefered: isPreferedProps, onRedirect } = this.props;
        const { hreflangs = [] } = this.props;
        const { location: { search } = {} } = history || {};
        const hrefLangPath = hreflangs?.find((hreflang) => hreflang.store_id === store_id) || url;

        const redirectUrl = `${hrefLangPath?.url}${search}`;

        if (locale) {
            this.setState({ isLoading: true });
            if (onRedirect) {
                onRedirect(redirectUrl, code);
            } else if (isPrefered || isPreferedProps) {
                const url = new URL(redirectUrl);
                setCookie(CURRENT_COUNTRY, code, COOKIE_LIFETIME);
                url.searchParams.append(NO_REDIRECT, true);
                window
                    .location
                    .assign(url.href);
            } else {
                window
                    .location
                    .assign(redirectUrl);
            }
        } else {
            this.toggleStoreSelectPopup(true);
        }
    }

    resetSearch() {
        this.setState({ searchValue: '' });
    }

    stopScroll() {
        const input = this.searchRef.current;
        if (input) {
            const top = input.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    }

    disableScrolling() {
        const { stopScroll } = this;
        const { device: { isMobile } } = this.props;
        if (isMobile) {
            document.addEventListener('touchend', stopScroll.bind(this));
            setTimeout(stopScroll.bind(this), TOUCH_TIMEOUT);
        }
    }

    enableScrolling() {
        const { stopScroll } = this;
        document.removeEventListener('touchend', stopScroll.bind(this));
    }

    resetCountrySelect() {
        this.setState({ searchValue: '' });
    }

    handleDirectRedirect() {
        const {
            selectedCountry,
            directRedirect
        } = this.state;

        if (directRedirect) {
            this.goToShop(selectedCountry);
        }
    }

    render() {
        return (
            <StoreSelector
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(StoreSelectorContainer);
